module.exports = __webpack_public_path__ + "img/ecef023.jpg";